var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelSubscriptionAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19 0C18.0129 0 17.2188 0.762375 17.2188 1.71V7.41C17.2188 8.35763 18.0129 9.12 19 9.12C19.9871 9.12 20.7812 8.35763 20.7812 7.41V3.51975C28.4703 4.36763 34.4375 10.6305 34.4375 18.24C34.4375 26.4266 27.5277 33.06 19 33.06C10.4723 33.06 3.5625 26.4266 3.5625 18.24C3.5625 15.1549 4.54219 12.2906 6.21953 9.918C6.77617 9.13425 6.56094 8.07263 5.74453 7.54537C4.92812 7.01813 3.82227 7.21763 3.27305 8.00138C1.20977 10.9155 0 14.4424 0 18.24C0 28.3147 8.50547 36.48 19 36.48C29.4945 36.48 38 28.3147 38 18.24C38 8.16525 29.4945 0 19 0ZM14.3242 11.3287C13.6266 10.659 12.4984 10.659 11.8082 11.3287C11.118 11.9985 11.1105 13.0815 11.8082 13.7441L17.7457 19.4441C18.4434 20.1139 19.5715 20.1139 20.2617 19.4441C20.952 18.7744 20.9594 17.6914 20.2617 17.0287L14.3242 11.3287Z",
    fill: "#ED7200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelSubscriptionAlert);
export default __webpack_public_path__ + "static/media/cancel-subscription-alert.4c57865bbef723c6ee2819cffa42c1a4.svg";
export { ForwardRef as ReactComponent };